import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'
import ReactAudioPlayer from 'react-audio-player';
import Lightbox from 'react-images';
import Dropzone from 'react-dropzone'

// import other components within the same project here
import Config from "composer/Config.jsx";

import Localization from "composer/Localization.jsx"

import FilePicker from "composer/views/FilePicker.jsx"

import {
  Card,
  CardHeader,
  CardMedia,
  CardContent,
  Button,
  Icon,
} from '@material-ui/core';

import {
  grey,
} from '@material-ui/core/colors'

class FilePickerCard extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      path: "",
      filename: "",
      extension: "",
      display_name: "",
      tn_file_id: -1,
      tn_path: "",
      create_time: "",
      file_size: "",
      lightboxIsOpen: false,
      changeFileConfirmed: false,
      trashFileIdList: [],
    };
    autoBind(this);

    this.refresh();
  }

  onFileDrop(files) {
    if (this.props.root.state.canUpload) {
      this.refs.filePicker.uploadFile(files);
    }
    else {
      this.props.root.showStorageQuotaDialog(this.props.root.emptyFunction);
    }
  }

  reuploadFile() {
    this.refs.filePicker.handleChangeClicked();
  }

  onUploadSuccess(res) {
    if (this.state.trashFileIdList.length > 0) {
      for (let i = 0; i < this.state.trashFileIdList.length; i++) {
        if (this.state.trashFileIdList[i] > -1) {
          this.props.root.refs.API.request("mark_file_as_trash", { file_id: this.state.trashFileIdList[i] });
        }
      }
    }
  
    if (this.props.parent.onUploadSuccess) {
      if (this.props.index !== undefined) {
        this.props.parent.onUploadSuccess(res, this.props.index);
      } else {
        this.props.parent.onUploadSuccess(res);
      }
    }
    this.setState({
      changeFileConfirmed: false,
      trashFileIdList: [],
    });
    this.refresh();
  }
  

  refresh() {
    if (this.props.file_id > 0) {
      let requestObj = {
        file_id: this.props.file_id,
      };
      this.props.root.refs.API.request("get_file_info", requestObj, this.getFileInfoOK, this.getFileInfoFailed);
    }
  }

  getFileInfoOK(res) {
    let fileData = res.body['result'];
    this.setState({
      path: fileData['path'],
      filename: fileData['filename'],
      extension: fileData['extension'],
      display_name: fileData['display_name'],
      tn_file_id: fileData['tn_file_id'],
      tn_path: fileData['tn_path'],
      create_time: fileData['create_time'],
      file_size: fileData['file_size'],
    });
    this.state.path = fileData['path'];
    this.state.filename = fileData['filename'];
    this.state.extension = fileData['extension'];
    this.state.display_name = fileData['display_name'];
    this.state.tn_file_id = fileData['tn_file_id'];
    this.state.tn_path = fileData['tn_path'];
    this.state.create_time = fileData['create_time'];
    this.state.file_size = fileData['file_size'];

    console.log("file data", fileData);
  }

  getFileInfoFailed(err) {
    console.log("get file info failed");
  }

  imagePreviewClicked() {
    this.setState({ lightboxIsOpen: true });
    this.state.lightboxIsOpen = true;
  }

  imageFullClicked() {
    this.setState({ lightboxIsOpen: false });
    this.state.lightboxIsOpen = false;
  }

  onChangeFileConfirm() {
    this.setState({
      changeFileConfirmed: true,
      trashFileIdList: [this.props.file_id],
    });
  }

  render() {
    let fileUrl = "";
    let thumbnailUrl = "";
    let fileTypeIcon = "create_new_folder";
    if (this.props.kind == 1) {
      fileTypeIcon = "audiotrack";
      if (this.props.file_id != 0) {
        fileUrl = Config.BASE_PATH() + this.state.path;
      }
    }
    if (this.props.kind == 2) {
      fileTypeIcon = "add_photo_alternate";
      if (this.props.file_id != 0) {
        fileUrl = Config.BASE_PATH() + this.state.path;
        thumbnailUrl = Config.BASE_PATH() + this.state.tn_path;
      }
    }

    if (this.state.changeFileConfirmed) {
      fileUrl = "";
    }

    return (
      <div>
        <FilePicker parent={this} root={this.props.root} ref="filePicker"
          localeId={this.props.localeId}
          allowedExtension={this.props.allowedExtension}
          onUploadSuccess={this.onUploadSuccess}
          onChangeFileConfirm={this.onChangeFileConfirm}
        />
        <Card>
          <If condition={(this.props.hasHeader? this.props.hasHeader : false)}>
            <Then>
              <CardHeader
                title="card header"
              />
            </Then>
          </If>
          <CardMedia image="/" style={{display:'flex', alignItems:'center', justifyContent:'center', backgroundColor:grey[100], height:"20vh"}}>
            <If condition={fileUrl == ""}>
              <Then>
                <div style={{width:'100%', height:'100%'}}>
                  <Dropzone onDrop={acceptedFiles => this.onFileDrop(acceptedFiles)}>
                    {({getRootProps, getInputProps}) => (
                        <div style={{width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center'}} {...getRootProps()}>
                          <input {...getInputProps()} />
                          <p style={{fontWeight:'bold'}}>{Localization.strings.FILEPICKER_MESSAGE}</p>
                        </div>
                    )}
                  </Dropzone>
                </div>
              </Then>
              <Else>
                <If condition={this.props.kind == 1}>
                  <Then>
                    <ReactAudioPlayer
                      src={fileUrl}
                      controls
                      style={{display:"block", margin:"auto"}}
                    />
                  </Then>
                </If>
                <If condition={this.props.kind == 2}>
                  <Then>
                    <img
                      style={{cursor: "pointer", maxHeight:"100%", maxWidth:"100%", display:"block", margin:"auto"}}
                      src={thumbnailUrl}
                      onClick={this.imagePreviewClicked}
                    />
                  </Then>
                </If>
              </Else>
            </If>
          </CardMedia>
          <CardContent>
            <div style={{textAlign:"center"}}>
              {Localization.strings.SUPPORTED_FILE_TYPE} {this.props.allowedExtension.replace(/,/g, " / ") + " "}
              <If condition={fileUrl != ""}>
                <Then>
                  <Button color="primary" onClick={this.reuploadFile}>
                    <Icon className="buttonIconLeft">delete</Icon>
                    {Localization.strings.DELETE}
                  </Button>
                </Then>
              </If>
            </div>
          </CardContent>
        </Card>
        <Lightbox
          images={[{src:fileUrl}]}
          isOpen={this.state.lightboxIsOpen}
          onClickImage={this.imageFullClicked}
          onClose={this.imageFullClicked}
          backdropClosesModal={true}
          showImageCount={false}
        />
      </div>
    )
  }
}

export default FilePickerCard;
